export default __webpack_public_path__ + "static/media/Amulet of the Esoteric Pendulum.e484868d.jpg";